let navigateFn = null;
let pendingPath = null;

export function toInAppPath(targetURL) {
  const url = new URL(targetURL);
  const link = url.searchParams.get("link");

  if (!link) return null;

  const decoded = decodeURI(link);
  return `/${decoded.replace("web+ipecsconnect:", "")}`;
}

// manifest.webmanifest sets launch_handler.client_mode to "focus-existing",
// so a reused window is only focused, never navigated/reloaded — this
// consumer is the only thing that routes it to the launch target, keeping
// an already-open, already-authenticated app instance off the slow
// cold-start path on every click-to-dial call.
export function registerLaunchQueueConsumer() {
  if (!("launchQueue" in window)) return;

  window.launchQueue.setConsumer((launchParams) => {
    if (!launchParams.targetURL) return;

    const path = toInAppPath(launchParams.targetURL);

    if (!path) return;

    if (navigateFn) {
      navigateFn(path);
    } else {
      // React hasn't mounted (or Wrapper is between mounts) yet, so hold
      // the target path and deliver it once a navigate function registers.
      pendingPath = path;
    }
  });
}

export function setLaunchNavigate(navigate) {
  navigateFn = navigate;

  if (navigate && pendingPath) {
    navigate(pendingPath);
    pendingPath = null;
  }
}
